export default function ExitReason({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Exit Reason")}</legend>
      <input
        name="exitReason"
        onChange={onChange}
        value={searchObject.exitReason || ""}
        className="form-control fontsize-legend"
      />
    </div>
  );
}
